var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRds(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 24,
    viewBox: "0 0 21 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-0.000244141 18.6971L2.4584 21.619L2.67947 21.3527V2.66328L2.4584 2.38086L-0.000244141 5.30175V18.6971Z",
    fill: "#132762"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.45898 21.6178L7.15691 23.9997L7.35231 23.6808L7.35551 0.249563L7.1602 0L2.45898 2.37426V21.6178Z",
    fill: "#2646A0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0002 5.30175L18.5409 2.38086L18.2659 2.4692L18.3205 21.3805L18.5409 21.619L21.0002 18.6974V5.30175Z",
    fill: "#3260E5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8425 23.9997L18.5405 21.6178V2.37426L13.8392 0L13.6169 0.30505L13.6201 23.653L13.8425 23.9997Z",
    fill: "#4474FB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.15991 0H13.8392V24H7.15991V0Z",
    fill: "#3260E5"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRds);
export default __webpack_public_path__ + "static/media/rds.057fb2d9.svg";
export { ForwardRef as ReactComponent };